import { html } from "lit-html";

let storyIncrement = 0;

const renderJsSnippet = (menuId: string) => {
    return html`
        <script>
            (() => {
                const menu = document.getElementById("${menuId}");
                menu?.addEventListener("uxMenuItemClick", (event) => {
                    if (!event.detail.name) {
                        // Only menu items with name can be current
                        return;
                    }
                    menu.querySelectorAll("ux-iws-sf-menu-item").forEach(
                        (item) => {
                            // Reset all other items to not current
                            item.current = item === event.target;
                        }
                    );
                });
            })();
        </script>
    `;
};

export const decoratorDefault = (Story) => {
    const menuId = `sf-menu-${++storyIncrement}`;
    return html`<div
            role="menu"
            id="${menuId}"
            style="display: flex; flex-direction: column; width: 280px;"
        >
            ${Story()}
        </div>
        ${renderJsSnippet(menuId)}`;
};

export const decoratorMenu = (Story) => {
    const menuId = `sf-menu-${++storyIncrement}`;
    return html`<div
            role="menu"
            id="${menuId}"
            style="display: flex; flex-direction: column; width: 280px; background: #f2f3f6; padding: 100px 0;"
        >
            ${Story()}
        </div>
        ${renderJsSnippet(menuId)}`;
};

export const getSubmenuSlot = (label: string, count: number = 3): string => {
    return Array(count)
        .fill("")
        .map(
            (_, index) =>
                `<ux-iws-sf-menu-item label="${label}.${index + 1}" name="${label}.${index + 1}"></ux-iws-sf-menu-item>`
        )
        .join("\n");
};
